import brain from 'brain';

/**
 * Active Shift Monitor
 * Automatically checks for shifts that are 3+ hours past their end time
 * and sends notifications to staff who are still clocked in.
 */

let monitorInterval: NodeJS.Timeout | null = null;
let isRunning = false;

const CHECK_INTERVAL = 60 * 60 * 1000; // 1 hour in milliseconds

/**
 * Start the active shift monitor
 * This will check for overtime shifts every hour
 */
export const startActiveShiftMonitor = () => {
  // Don't start if already running
  if (isRunning) {
    return;
  }

  isRunning = true;

  // Run immediately on start
  checkActiveShifts();

  // Then run every hour
  monitorInterval = setInterval(() => {
    checkActiveShifts();
  }, CHECK_INTERVAL);
};

/**
 * Stop the active shift monitor
 */
export const stopActiveShiftMonitor = () => {
  if (monitorInterval) {
    clearInterval(monitorInterval);
    monitorInterval = null;
    isRunning = false;
  }
};

/**
 * Check for active shifts and send notifications
 */
const checkActiveShifts = async () => {
  try {
    const response = await brain.check_active_shifts();
    
    if (!response.ok) {
      console.error('[ActiveShiftMonitor] Check failed:', response.status);
    }
  } catch (error) {
    console.error('[ActiveShiftMonitor] Error checking active shifts:', error);
  }
};

/**
 * Check if monitor is currently running
 */
export const isMonitorRunning = () => isRunning;
